<div class="mx-auto p-4 bg-white rounded-md">
  <!-- Título -->
  <h2 *ngIf="!isLoading" class="text-xl font-bold text-gray-800 mb-4">Comentários</h2>
  <form class="mt-6" (ngSubmit)="submitComment()" *ngIf="!isLoading">
    <label for="comment" class="block text-sm font-medium text-gray-700 mb-2">Adicionar um comentário</label>
    <textarea
      [(ngModel)]="newComment"
      name="comment"
      id="comment"
      rows="3"
      class="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      placeholder="Escreva seu comentário aqui..."
      required
    ></textarea>
    <button
      type="submit"
      class="mt-3 mb-5 px-4 py-2 bg-[var(--lightRed)] text-white rounded-md hover:bg-blue-600 transition"
      [disabled]="!newComment.trim()"
    >
      Enviar
    </button>
  </form>
  <!-- Exibição de carregamento enquanto os comentários estão sendo carregados -->
  <div *ngIf="isLoading" class="text-center text-gray-600 mb-4">
    <div class="flex justify-center items-center flex-col gap-5">
      <div class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg"></div>
      <span class="text-[--lightRed]">Carregando comentários...</span>
    </div>
  </div>

  <!-- Contagem de comentários (aparece somente quando não está carregando) -->
  <p *ngIf="!isLoading" class="text-sm text-gray-600 mb-4">
    <span id="comment-count" class="font-medium">{{ comments.length }}</span> comentários
  </p>

  <!-- Lista de comentários -->
  <div *ngIf="!isLoading" id="comments-list" class="space-y-4">
    <div *ngFor="let comment of comments" class="flex items-start space-x-3">
      <div class="flex flex-row gap-4">
        <i 
        title="Excluir seu comentários"
        *ngIf="comment.user.id == userId "
        class='bx bx-trash content-center cursor-pointer text-red-600'
        (click)="deleteComment(comment.id)"
        ></i>
        <div class="flex-shrink-0 content-center">
          <img
            [src]="comment.user.picture"
            alt="{{ comment.user.name }}"
            class="w-8 h-8 bg-gray-200 rounded-full object-cover content-center"
          />
        </div>
        <div>
          <p class="text-sm font-semibold text-gray-800">{{ comment.user.name }}</p>
          <p class="text-sm text-gray-600">{{ comment.comment }}</p>
          <span class="text-xs text-gray-400">{{ comment.created_at | date: 'short' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Exibição de mensagem quando não há comentários -->
  <p *ngIf="!isLoading && comments.length === 0" class="text-gray-600 mt-4">Nenhum comentário encontrado.</p>


</div>
